var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRestore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3A59",
    fillRule: "evenodd",
    d: "M16.92 11.188c-.44-.14-.908.103-1.048.542-.78 2.455-3.079 4.103-5.719 4.103-3.301 0-5.986-2.617-5.986-5.833s2.685-5.834 5.986-5.834c1.44 0 2.799.502 3.871 1.392l-1.805-.297c-.458-.084-.883.232-.958.685-.075.455.232.884.687.958l3.538.585c.046.007.092.01.136.01.1 0 .196-.017.286-.05.031-.012.056-.033.086-.05.055-.028.113-.053.16-.093.03-.024.05-.059.075-.087.04-.04.081-.08.11-.13.021-.036.03-.078.045-.118.02-.05.047-.095.057-.15l.628-3.333c.085-.452-.212-.89-.665-.973-.45-.082-.888.212-.973.664l-.227 1.2c-1.386-1.2-3.164-1.88-5.05-1.88C5.933 2.5 2.5 5.865 2.5 10c0 4.137 3.433 7.5 7.653 7.5 3.369 0 6.305-2.115 7.308-5.264.139-.439-.103-.907-.542-1.047",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRestore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/restore.edbb667f.svg";
export { ForwardRef as ReactComponent };